import { useEffect, useState } from 'react';
import { api, apiError } from '@/lib/pos-api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

export default function SupplierSyncDialog({ supplier, onClose, onSaved }) {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState('');
  const [source, setSource] = useState('kas');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    api.get('/supplier-directory').then(({ data }) => {
      if (!live) return;
      setItems(data.items); setSelected(supplier.kas_supplier_id || '');
    }).catch(e => { if (live) setError(apiError(e)); });
    return () => { live = false; };
  }, [supplier.id, supplier.kas_supplier_id]);
  const target = items.find(s => s.id === selected);
  const save = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await api.post('/supplier-directory/resolve', { supplier_id: supplier.id, revision: supplier.revision,
        source, kas_supplier_id: source === 'separate' ? null : selected, kas_version: source === 'separate' ? null : target?.version });
      toast.success('Pilihan disimpan. Sinkronisasi diproses.'); onSaved(); onClose();
    } catch (e) { setError(apiError(e)); } finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="bg-ui-card text-ui-text border-ui-line max-h-[90dvh] overflow-y-auto">
      <DialogHeader><DialogTitle>Periksa pasangan supplier</DialogTitle><DialogDescription>Hanya master nama, telepon, dan alamat. Riwayat utang dan transaksi tidak digabung atau diubah.</DialogDescription></DialogHeader>
      <div className="rounded border p-3 text-sm"><b>POS: {supplier.name}</b><p>{supplier.phone || 'Telepon kosong'}</p><p>{supplier.address || 'Alamat kosong'}</p></div>
      <label className="text-sm">Supplier di Kas
        <select aria-label="Supplier di Kas" value={selected} disabled={busy || source === 'separate'} onChange={e => setSelected(e.target.value)} className="w-full mt-1 rounded border bg-ui-card p-2">
          <option value="">Pilih pasangan</option>
          {items.filter(s => !supplier.kas_supplier_id || s.id === supplier.kas_supplier_id).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </label>
      {target && <div className="rounded border p-3 text-sm"><b>Kas: {target.name}</b><p>{target.phone || 'Telepon kosong'}</p><p>{target.address || 'Alamat kosong'}</p></div>}
      <label className="text-sm">Data yang akan dipakai
        <select aria-label="Data yang akan dipakai" value={source} disabled={busy} onChange={e => setSource(e.target.value)} className="w-full mt-1 rounded border bg-ui-card p-2">
          <option value="kas">Gunakan nama dan kontak Kas</option><option value="pos">Gunakan nama dan kontak POS</option>
          {!supplier.kas_supplier_id && <option value="separate">Bukan supplier yang sama — buat terpisah</option>}
        </select>
      </label>
      {error && <p role="alert" className="text-sm text-danger-readable">{error}</p>}
      <Button disabled={busy || (source !== 'separate' && !target)} onClick={save}>{busy ? 'Menyimpan…' : 'Simpan pilihan'}</Button>
    </DialogContent>
  </Dialog>;
}
